import * as React from 'react';
import { observer } from 'mobx-react';
import { IconButton, Button, Menu, MenuItem, Tooltip } from '@material-ui/core';
import theme from './config/theme';
import ImgMapa from '@material-ui/icons/Place';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined'
import HistoryIcon from '@material-ui/icons/History';
import AjtApp, { AppHeader, AppToolBar, AppRoutes, AppRoute, AppToolBarElements } from 'ajt-app';
import AppState from './states/AppState';
import PantMapaLots from './pantalles/PantMapaLots';
import { IUrl } from './interfaces/IMapConfig';
import Util from './config/util';

const appState = new AppState();

@observer
class App extends React.Component<{}, {}> {

    private handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        appState.setAnchorEl(event.currentTarget)
    }

    private handleMenuClose = (index: number) => {
        appState.setAnchorEl(null);
        if (index >= 0) {
            let url: string = Util.replaceAll(appState.mapConfig.descarrega[index].url, '[PartitCod]', appState.usr.partitCod.toString());
            let name: string = Util.replaceAll(appState.mapConfig.descarrega[index].name, '[PartitNom]', appState.usr.partitNom);
            window.open(url, name);
        }
    }

    private handlePrintMapa = () => {
        window.open(appState.mapConfig.mapLotsUrl + '?Session=' + appState.usr.sesCod + '&Usuari=' + appState.usr.userId + '&EleCod=' + appState.ele.eleCod.toString(), appState.ele.eleDesc + appState.usr.userId);
    }

    render() {
        if (!appState || !appState.configOk) {
            return null;
        }
        return (
            <AjtApp appState={appState} theme={theme}>
                <AppHeader/>
                <AppToolBar style={{zIndex: 10}} separatedElements={true}>
                    <AppToolBarElements alignment="left">
                        <div style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxHeight: 48}}>{appState.titol}</div>
                    </AppToolBarElements>
                    <AppToolBarElements alignment="right">
                        <div style={{right: 0, minWidth: 500}}>
                            <Tooltip title="Seleccionar emplaçaments">
                                <Button variant="outlined" onClick={() => { appState.showEmpla(true) }}>EMPLAÇAMENTS</Button>
                            </Tooltip>
                            <Tooltip title="Imprimir mapa">
                                <IconButton onClick={() => { this.handlePrintMapa() }}>
                                    <PrintOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            {appState.mapConfig.descarrega && appState.mapConfig.descarrega.length > 0 && <><Button onClick={this.handleMenuClick}>Descàrrega de mapes ...</Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={appState.anchorEl}
                                    keepMounted
                                    open={Boolean(appState.anchorEl)}
                                    onClose={this.handleMenuClose.bind(this, -1)}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                                >
                                    {appState.mapConfig.descarrega.map((item: IUrl, index: number) => {
                                        return (<MenuItem key={'dsc' + index} onClick={this.handleMenuClose.bind(this, index)}>{Util.replaceAll(item.name, '[PartitNom]', appState.usr.partitNom)}</MenuItem>);
                                    })}
                                </Menu>
                            </>}
                            {!appState.readOnly && appState.lotsAnt.length > 0 && <Tooltip title="Utilitzar selecció d'eleccions anteriors">
                                <IconButton onClick={() => { appState.showCopyEleAnt(true, 'L', () => {
                                        if (appState.mpState) {
                                            appState.mpState.getCatsLots();
                                            //appState.mpState.setSelect(this.lotsLayer, '');
                                            //appState.mpState.lotsLayer.getSource().refresh();
                                            appState.mpState.removeLotsLayer();
                                            appState.mpState.addLotsLayer();
                                        }
                                    }) 
                                }}>
                                    <HistoryIcon />
                                </IconButton>
                            </Tooltip>}
                            <Tooltip title="Informació">
                                <IconButton onClick={() => { appState.showInfo(true) }}>
                                    <InfoOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Sortir">
                                <IconButton onClick={() => { appState.doLogout() }}>
                                    <ExitToAppIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </AppToolBarElements>
                </AppToolBar>
                <AppRoutes>
                    <AppRoute nom="MapaLots" label=" " path="/" icon={ImgMapa} component={PantMapaLots} />
                </AppRoutes>
            </AjtApp>
        );
    }
}

export default App;
